// extracted by mini-css-extract-plugin
export default {"tag":"ia","tags":"ja","blinking":"ka","gradientShift":"la","float":"ma","move":"na","scroll":"oa"};